








































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import VueGallery from 'vue-gallery';
import { DATA } from '@/config/data';
import { Order } from '@/models/order';
import { DepositModel } from '@/models/deposit';
import { FileType } from '@/models/file-type';
import { OrderComplainModel } from '@/models/order-complain';

import formatNumber from '@/shared/filters/format-number';
import utility from '@/utility/utility';
import { APP_CONFIG } from '@/config/app-config';

@Component({
    components: {
        'gallery': VueGallery
    }
})
export default class DetailComplain extends Vue {
    private eventEmit = {
        eventChangeDataComplain: 'eventChangeDataComplain'
    };

    @Prop({default: null})
    private order!: Order;
    @Prop({default: null})
    private complain!: OrderComplainModel;
    @Prop({default: true})
    private showReason!: Boolean;
    @Prop({default: ''})
    private transactionCode: String;

    get APP_CONFIG() {
        return APP_CONFIG;
    }

    get quotationCode() {
        if (this.transactionCode) {
            return this.transactionCode.toString().startsWith('QT') ? this.transactionCode : ('QT' + this.transactionCode);
        }
        if (this.order) {
            const ord: any = this.order;
            if (ord.transactionCode) {
                return ord.transactionCode.toString().startsWith('QT') ? ord.transactionCode : ('QT' + ord.transactionCode);
            }
            if (ord.id) {
                return 'QT' + ord.id;
            }
        }
        if (this.complain) {
            const comp: any = this.complain;
            if (comp.transactionCode) {
                return comp.transactionCode.toString().startsWith('QT') ? comp.transactionCode : ('QT' + comp.transactionCode);
            }
            if (comp.orderId) {
                return 'QT' + comp.orderId;
            }
        }
        if (this.$route && this.$route.params && this.$route.params.orderId && this.$route.params.orderId !== '0') {
            return 'QT' + this.$route.params.orderId;
        }
        return '';
    }

    get orderType() {
        if (this.complain && this.complain.id > 0 && this.complain.orderType) {
            return this.complain.orderType;
        }
        return this.$route.params.orderType ? Number(this.$route.params.orderType) : 1;
    }

    private complainOptions = [
        { value: 1, name: 'Hàng không đúng yêu cầu (Thiếu, sai mẫu, kém chất lượng)', selected: false },
        { value: 2, name: 'Hỏng hàng', selected: false },
        { value: 3, name: 'Mất hàng', selected: false },
        { value: 4, name: 'Sai số liệu', selected: false },
        { value: 5, name: 'Khác', selected: false }
    ];


    private complainValues = {
        indemnity: '',
        content: '',
        resMethod: 0,
        complainSelected: [] as any,
        images: [] as FileType[],
        files: [] as FileType[],
        noteForUser: ''
    };

    private index = null

    get imgs() {
        return this.complainValues.images.map(x => { return x.src; });
    }

    get complainMethods() {
        return DATA.complainMethod;
    }

    @Watch('complainValues', { immediate: true, deep: true })
    private onEmitDataComplain() {
        this.$emit(this.eventEmit.eventChangeDataComplain, this.complainValues);
    }

    @Watch('complain', { immediate: true, deep: true })
    private onComplainChange() {
        if (this.complain.id > 0) {
            this.complainOptions[0].selected = this.complain.isMissGood || false;
            this.complainOptions[1].selected = this.complain.isBroken || false;
            this.complainOptions[2].selected = this.complain.isLoss || false;
            this.complainOptions[3].selected = this.complain.isOption || false;
            this.complainOptions[4].selected = this.complain.isOther || false;
            this.complainValues = {
                ...this.complainValues,
                indemnity: formatNumber(this.orderType === APP_CONFIG.ORDER_TYPE.quotation ? (this.complain.amount || 0) : (this.complain.amountNDT || 0), '0,0.[000000000000]'),
                resMethod: this.complain.resMethod,
                content: this.complain.complainText,
                noteForUser: this.complain.noteForUser,
                images: (this.complain.img ? this.complain.img.split(';').map((v, i) => {
                    const item = new FileType();
                    item.id = i;
                    item.src = `${APP_CONFIG.settings.firebase_storage}/${APP_CONFIG.settings.firebase_prefix}%2Fcomplain%2F${v}?alt=media`
                    item.fileName = v;
                    return item;
                }) : null) || [],
                files: (this.complain.files ? this.complain.files.split(';').map((v, i) => {
                    const item = new FileType();
                    item.id = i;
                    item.src = `${APP_CONFIG.settings.firebase_storage}/${APP_CONFIG.settings.firebase_prefix}%2Fcomplain%2F${v}?alt=media`
                    item.fileName = v;
                    return item;
                }) : null) || [],
                complainSelected: this.complainOptions.filter(x => x.selected === true)
            }
        }
    }

    onComplainOptChange(option: any) {
        this.complainOptions = this.complainOptions.map(co => {
            return {
                ...co,
                selected: co.value === option.value ? !co.selected : co.selected
            };
        });

        this.complainValues.complainSelected = this.complainOptions.filter(x => x.selected === true);
    }

    onChangeFile(event: any, file_type: any) {
        const onLoad = (file: any, id: number) => {
            const reader = new FileReader();
            reader.onload = e => {
                const arrFileType = file.name.split('.');
                if(file_type == 1) {
                    this.complainValues.images.push({
                        fileName: `${this.order.id}_${utility.randomString(35)}.${arrFileType[arrFileType.length - 1]}` ,
                        src: reader.result || undefined,
                        file,
                        id
                    });
                }
                else {
                    this.complainValues.files.push({
                        fileName: `${this.order.id}_${utility.randomString(35)}.${arrFileType[arrFileType.length - 1]}` ,
                        src: reader.result || undefined,
                        file,
                        id
                    });
                }
            };
            reader.readAsDataURL(file);
        }

        if (event.target.files && event.target.files[0]) {
            let i = 1;
            const files = event.target.files;
            for (const file of files) {
                if(file.size / 1024 / 1024 > 10) {
                    Vue.notify({ group: 'foo', type: 'error', title: 'Thông báo!', text: 'Dung lượng file không được lớn hơn 10Mb!' });
                    break;
                }
                onLoad(file, i);
                i++;
            }
        }
    }

    onDeleteImage(index: number, file_type: number) {
        if(file_type == 1) {
            this.complainValues.images.splice(index, 1);
            (this.$refs.fileInput as any).value = null;
        }
        else {
            this.complainValues.files.splice(index, 1);
            (this.$refs.fileInput2 as any).value = null;
        }        
    }
    
    showGallery(index: any) {
        this.index = index;
    }
    
    showFile(index: any) {
        if(this.complainValues && this.complainValues.files.length > index) {
            let file_url = (this.complainValues.files[index].src || '').toString();
            window.open(file_url, '_blank');
        }
    }
}

